import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import setClass from '../../common/set-class';
import Icon from '../icon';
const TableRow = ({ item, index, columns, ExpandedComponent, getIsRowExpandable, }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpand = (event) => {
        if (!ExpandedComponent || !getIsRowExpandable(item)) {
            return;
        }
        if (event.target.closest('.b-table__prevent-row-toggle')) {
            return;
        }
        setIsExpanded((value) => !value);
    };
    return (React.createElement("li", { className: "b-table__row-wrapper" },
        React.createElement("div", { onClick: toggleExpand, className: setClass('b-table__row', ExpandedComponent && getIsRowExpandable(item) && '--expandable') },
            ExpandedComponent && (React.createElement("div", { className: "b-table__cell b-table__expand_cell" }, getIsRowExpandable(item) && (React.createElement(Icon, { name: "angle-down", className: setClass('b-table__caret', 'b-table__expand-indicator', isExpanded && '--turned') })))),
            columns.map(({ className, ratio, Cell, fieldName }) => (React.createElement("div", { key: fieldName, className: setClass('b-table__cell', className), style: { flexGrow: ratio } }, Cell ? React.createElement(Cell, { item: item, index: index }) : item[fieldName])))),
        isExpanded && React.createElement(ExpandedComponent, { item: item })));
};
TableRow.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number,
    ExpandedComponent: PropTypes.elementType,
    getIsRowExpandable: PropTypes.func,
    columns: PropTypes.arrayOf(PropTypes.shape({
        fieldName: PropTypes.string.isRequired,
        className: PropTypes.string,
        ratio: PropTypes.number,
        Cell: PropTypes.elementType,
    })).isRequired,
};
TableRow.defaultProps = {
    index: undefined,
    ExpandedComponent: undefined,
    getIsRowExpandable: undefined,
};
export default memo(TableRow);
